module.exports = __webpack_public_path__ + "static/06-b001064171c67806f3ea9992635d2cac.jpg";